import { render } from "./FinalApproval.vue?vue&type=template&id=30499f01&scoped=true"
import script from "./FinalApproval.vue?vue&type=script&lang=js"
export * from "./FinalApproval.vue?vue&type=script&lang=js"

import "./FinalApproval.vue?vue&type=style&index=0&id=30499f01&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30499f01"]])

export default __exports__